const CATALOG_CONTAINER_BASE_SCREEN_WIDTH = 1920;
const CATALOG_CONTAINER_BASE_WIDTH = 1280;
const CATALOG_CONTAINER_BASE_RATIO = CATALOG_CONTAINER_BASE_WIDTH / CATALOG_CONTAINER_BASE_SCREEN_WIDTH;
const CATALOG_CONTAINER_SMALL_SCREEN_WIDTH = 1024;
const CATALOG_CONTAINER_SMALL_SCREEN_RATIO = 0.94;
const CATALOG_CONTAINER_MIN_WIDTH = 320;

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const getCatalogContainerSize = (width: number): number => {
  if (width <= CATALOG_CONTAINER_SMALL_SCREEN_WIDTH) {
    return Math.max(CATALOG_CONTAINER_MIN_WIDTH, Math.floor(width * CATALOG_CONTAINER_SMALL_SCREEN_RATIO));
  }

  if (width >= CATALOG_CONTAINER_BASE_SCREEN_WIDTH) {
    return Math.floor(width * CATALOG_CONTAINER_BASE_RATIO);
  }

  const progress = clamp(
    (CATALOG_CONTAINER_BASE_SCREEN_WIDTH - width) /
      (CATALOG_CONTAINER_BASE_SCREEN_WIDTH - CATALOG_CONTAINER_SMALL_SCREEN_WIDTH),
    0,
    1,
  );
  const ratio =
    CATALOG_CONTAINER_BASE_RATIO + progress * (CATALOG_CONTAINER_SMALL_SCREEN_RATIO - CATALOG_CONTAINER_BASE_RATIO);

  return Math.floor(width * ratio);
};
